const configService125 = {
  apiUrl: process.env.API_LOCAL
}

export default configService125



// WEBPACK FOOTER //
// ./src/services/config125.js